var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quiz-result"},[_c('base-title',{staticClass:"sticky-title",attrs:{"title":`Quiz result: ${_vm.quiz.name}`}}),_c('div',{staticClass:"quiz-user-result"},[_c('quiz-test-result',{attrs:{"quiz":_vm.quiz,"openComment":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }